import {TrmzFileDTO} from "@web-libs/features/files/trmz-file/api/trmz-file.types";
import {User, UserType} from "@web-libs/features/users/domain/user.types";
import {TrmzFileDTOConverter} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";

export type UserDTO = {
    id: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    avatar: TrmzFileDTO
}

export const parseUserDTO = (dto: UserDTO, converter: TrmzFileDTOConverter): User => {
    return {
        id: dto.id,
        firstName: dto.firstName,
        lastName: dto.lastName,
        username: dto.username,
        avatarUrl: dto.avatar ? converter.parseDTOToUrl(dto.avatar) : undefined
    }
}

type NestedUserTypeDTO = {
    id: string;
    userType: UserTypeDTO;
}

type UserTypeDTO = {
    id: string;
    name: UserType;
    viewName: string;
}

export type OwnUserDTO = {
    id: string;
    username: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    birth?: Date;
    userTypes: NestedUserTypeDTO[];
}
